import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import moment from 'moment';
import { browserHistory } from 'react-router';
import { toast } from 'react-toastify';
import { loggedOutDraftApproval } from 'redux/modules/draftPosts';
import { LoggedOutLayout } from 'containers';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import { ChatAreaInput, Modal, PostPlatformPreview, PostListContent, PageHeader } from 'components';
import { postFeedback } from 'redux/modules/feedback';
import { getSocialAccounts, setCurrentOrganization } from '../../redux/modules/organization';
import { populateComposebox } from 'redux/modules/composeboxForm';
import convertPost from '../../helpers/convertPost';
import { compareByPlacement } from '../../helpers/convertPost';
import * as styles from './LoggedOutDraftApproval.scss';
import { connect } from 'react-redux';
var DraftApproval = (_dec = connect(function (state, props) {
  return {
    approvingDraft: state.draftPosts.loggedOutDraftApprovalInProgress,
    draftPosts: state.draftPosts,
    user: state.auth.user
  };
}, {
  loggedOutDraftApproval: loggedOutDraftApproval,
  populateComposebox: populateComposebox,
  postFeedback: postFeedback,
  setCurrentOrganization: setCurrentOrganization,
  getSocialAccounts: getSocialAccounts
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(DraftApproval, _Component);

  var _super = _createSuper(DraftApproval);

  function DraftApproval(props) {
    var _this;

    _classCallCheck(this, DraftApproval);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleEdit", function (post) {
      var addPublishAt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var initialValues = convertPost(post, false);
      var orgId = _this.props.draftPosts.posts[0].OrganizationId;

      if (addPublishAt) {
        // this makes the composebox default to 'Schedule' instead of 'Save As Draft'
        initialValues.publishAt = moment().add(1, 'day');
      }

      _this.props.populateComposebox(initialValues, orgId);

      browserHistory.push({
        pathname: "/org/".concat(orgId, "/compose"),
        state: {
          modal: false,
          chatPopupOpen: true
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handlePostFeedback", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$props$gotoNext, gotoNext, linkUrl;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this$props$gotoNext = _this.props.gotoNext, gotoNext = _this$props$gotoNext === void 0 ? function () {
                console.log('no-op');
              } : _this$props$gotoNext;
              linkUrl = "https://".concat(window.location.hostname, "/org/").concat(_this.props.draftPosts.posts[0].Organization.id, "/publishing/draft-posts");
              console.log('gotoNext = ', gotoNext);
              _context.next = 5;
              return _this.props.postFeedback({
                linkUrl: linkUrl,
                orgId: parseInt(_this.props.draftPosts.posts[0].Organization.id),
                orgName: _this.props.draftPosts.posts[0].Organization.name,
                message: _this.state.feedbackMessage,
                subjectType: 'DraftPost',
                subjectId: _this.state.activeDraftPostId,
                token: _this.props.postHash
              });

            case 5:
              gotoNext();

              _this.setState({
                activeDraftPostId: null,
                feedbackMessage: '',
                showFeedbackModal: false
              }, function () {
                toast.success('Thank you for your feedback!');
              });

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    var _post = props.post;

    _post.S3Files.sort(compareByPlacement);

    var images = _post.S3Files && _post.S3Files.length ? _post.S3Files.map(function (file) {
      return file.fullyQualifiedUrl;
    }) : [];
    var postType = 'textPost';

    if (!images.length && _post.linkUrl) {
      postType = 'linkPost';
    } else {
      postType = 'imagePost';
    }

    var messagesData = {};
    _post.SocialAccountPosts && !!_post.SocialAccountPosts.length ? _post.SocialAccountPosts.forEach(function (sap) {
      messagesData[sap.SocialAccount.platform.split(' ')[0].toLowerCase()] = sap.message;
    }) : null;
    _this.state = {
      DraftPost: _post.DraftPost,
      messages: _objectSpread({
        global: _post.message
      }, messagesData),
      existingPostId: _post.id,
      images: images,
      postType: postType,
      showFeedbackModal: false,
      activeDraftPostId: null,
      feedbackMessage: ''
    };
    return _this;
  }

  _createClass(DraftApproval, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.setCurrentOrganization(this.props.post.OrganizationId);
      this.props.getSocialAccounts(this.props.post.OrganizationId);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          isLast = _this$props.isLast,
          gotoNext = _this$props.gotoNext,
          post = _this$props.post,
          postHash = _this$props.postHash;

      if (!post) {
        return null;
      }

      var platforms = post.SocialAccountPosts.map(function (sap) {
        return sap.SocialAccount.platform.split(' ').join('').toLowerCase();
      });
      var videos = this.state.videoUrl && this.state.postType === 'videoPost' ? [this.state.videoUrl] : [];
      var passedInSocialAccounts = post.SocialAccountPosts.map(function (sap) {
        return sap.SocialAccount;
      });
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostPlatformPreview, {
        passedInSocialAccounts: passedInSocialAccounts,
        platforms: platforms,
        images: this.state.postType === 'linkPost' && post._parsedLink.imageUrl ? [post._parsedLink.imageUrl] : this.state.images,
        messages: this.state.messages,
        link: this.state.postType === 'linkPost' ? post.linkUrl : null,
        linkTitle: post._parsedLink ? post._parsedLink.title : '',
        linkDescription: post._parsedLink ? post._parsedLink.description : '',
        linkCaption: post._parsedLink ? post._parsedLink.caption : '',
        postOrgId: post.OrganizationId,
        postDate: this.state.publishAt ? moment(this.state.publishAt) : null,
        postType: this.state.postType,
        videos: post.videoUrl ? [post.videoUrl] : []
      })), post.DraftPost.suggestedPublishAt && /*#__PURE__*/React.createElement("div", {
        style: {
          color: '#333333',
          fontSize: 13,
          margin: 16
        }
      }, "This post ", post.DraftPost.approvedAt ? 'is' : 'will be', " scheduled for", ' ', moment(post.DraftPost.suggestedPublishAt).format('dddd M/D/YYYY'), " at", ' ', moment(post.DraftPost.suggestedPublishAt).format('h:mm A'), ' '), !post.DraftPost.approvedAt && /*#__PURE__*/React.createElement("div", {
        className: styles.buttonWrap
      }, /*#__PURE__*/React.createElement(RaisedButton, {
        backgroundColor: "#417505",
        disabled: this.props.approvingDraft,
        labelColor: "white",
        onClick: function onClick() {
          _this2.props.loggedOutDraftApproval(postHash, post.id).then(function () {
            gotoNext();
          });
        },
        label: this.props.approvingDraft ? /*#__PURE__*/React.createElement("i", {
          className: "fa fa-spin fa-spinner",
          style: {
            fontSize: 20
          }
        }) : 'Approve Post'
      }), /*#__PURE__*/React.createElement(FlatButton, {
        onClick: function onClick() {
          _this2.setState({
            showFeedbackModal: true,
            activeDraftPostId: post.DraftPostId
          });
        },
        label: "Needs Changes",
        style: {
          marginTop: 8
        }
      })), /*#__PURE__*/React.createElement(Modal, {
        actions: [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Cancel",
          onClick: function onClick() {
            _this2.setState({
              showFeedbackModal: false
            });
          },
          style: {
            marginRight: 24
          }
        }), /*#__PURE__*/React.createElement(RaisedButton, {
          secondary: true,
          label: "Submit",
          onClick: function onClick() {
            _this2.props.handleFeedbackSent(_this2.state.activeDraftPostId);

            _this2.handlePostFeedback(gotoNext);
          }
        })],
        leftActions: this.props.user ? [/*#__PURE__*/React.createElement(RaisedButton, {
          label: "Edit Post",
          onClick: function onClick() {
            _this2.handleEdit(post);
          },
          style: {
            marginRight: 24
          }
        })] : [],
        title: "Draft Post Feedback",
        open: this.state.showFeedbackModal,
        onRequestClose: function onRequestClose() {
          _this2.setState({
            showFeedbackModal: false
          });
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.modalTextWrap
      }, "Not quite right? Let us know what changes you'd like and we'll get another draft ready for you."), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 500,
          margin: '0 auto'
        }
      }, /*#__PURE__*/React.createElement(PostListContent, {
        style: {
          marginBottom: 24,
          marginTop: 48,
          padding: 0
        },
        videoUrl: post.videoUrl,
        image: this.state.postType === 'linkPost' && post._parsedLink.imageUrl ? post._parsedLink.imageUrl : this.state.images[0],
        message: post.message ? post.message : post.linkUrl ? post.linkTitle : 'No message'
      }), /*#__PURE__*/React.createElement("h4", {
        className: styles.modalInputLabel
      }, "Post Feedback"), /*#__PURE__*/React.createElement(TextField, {
        placeholder: "Enter changes here",
        id: "feedbackMessage",
        multiLine: true,
        onChange: function onChange(e, value) {
          _this2.setState({
            feedbackMessage: value
          });
        },
        style: {
          width: '100%',
          marginBottom: 32
        },
        value: this.state.feedbackMessage
      }))));
    }
  }]);

  return DraftApproval;
}(Component)) || _class);
export { DraftApproval as default };